/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 痙攣(部位)
 */
export type FindEmsContactSpasmPartsEnum =
  (typeof FindEmsContactSpasmPartsEnum)[keyof typeof FindEmsContactSpasmPartsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactSpasmPartsEnum = {
  WHOLE_BODY: 'WHOLE_BODY',
  RIGHT_UPPER_LIMB: 'RIGHT_UPPER_LIMB',
  LEFT_UPPER_LIMB: 'LEFT_UPPER_LIMB',
  RIGHT_LOWER_LIMB: 'RIGHT_LOWER_LIMB',
  LEFT_LOWER_LIMB: 'LEFT_LOWER_LIMB',
} as const;
